import styled from 'styled-components';
import { motion } from 'framer-motion';

export const MotionBox = styled(motion.div)`
  display: flex;
`;
